import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'

const ACC_TYPES = {
    MANAGER: 'supplier-admin',
    SUPPLIER: 'supplier',
}

export const useSupplierProfile = () => {
    const cognitoUser = JSON.parse(localStorage.getItem('cognitoUser'))
    const { accessToPages: accessToPagesFromLS } = JSON.parse(localStorage.getItem('supplier'))
    const { attributes = {}, username = '' } = cognitoUser
    const { managers, loadingManagers } = useSelector(GET_STORE.MANAGERS)
    const { loadingUpdateSupplier, loadingGetShopifyProducts, shopifyProductsError, shopifyProducts, supplier } = useSelector(GET_STORE.SUPPLIER)

    const [accessToPages, setAccessToPages] = useState(null)

    const authType = attributes['custom:type'] || ACC_TYPES.SUPPLIER
    const isSupplier = authType === ACC_TYPES.SUPPLIER
    const isManager = authType === ACC_TYPES.MANAGER

    useEffect(() => {
        // Use accessToPages from LS if user logged in as Supplier
        if (isSupplier) setAccessToPages(accessToPagesFromLS)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // Wait for fetching managers and use accessToPages from current manager profile if user logged in as Manager
        if (isManager && managers && !loadingManagers) {
            const accessToPages = managers.find(({ supplierAdminId }) => supplierAdminId === username)?.accessToPages
            return setAccessToPages(accessToPages)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingManagers, managers])

    const supplierId = isSupplier ? cognitoUser.username : supplier?.supplierId
    const supplierAdminId = isManager ? cognitoUser.username : undefined

    return {
        accessToPages,
        authType,
        isShopifyConnected: !!supplier?.shopify,
        loadingUpdateSupplier,
        loadingGetShopifyProducts,
        shopifyProducts,
        shopifyProductsError,
        supplier,
        supplierId,
        supplierAdminId, // manager
    }
}
